//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

(function() {
  angular.module('curalate').component('magentoIntegration', {
    bindings: {
      magentoFormValues: '=',
    },
    template: require('@legacy-components/ecommerce-integrations/integrations/magento-integration.html'),
  });
})();
